/**
 * Scans a method's own body tokens (CsMemberScanner's `member.bodyTokens`)
 * for calls made on known dependency fields (`_field.Method(...)`). Only
 * single-hop calls are detected — a chained call like `_field.Sub.Method()`
 * is reported against `Sub` as the method name on `_field`'s type, not
 * resolved further into `Sub`'s own type. That would need a second pass
 * once `Sub`'s declared type is known (out of scope for v1).
 * @param {{type: string, value: string}[]} bodyTokens
 * @param {Map<string, string>} fieldTypeMap - field name -> declared type, from the caller's constructor dependencies
 * @returns {{targetField: string, targetType: string, targetMethodName: string}[]}
 */
export function scanMethodBodyCalls(bodyTokens, fieldTypeMap) {
  const calls = [];
  for (let i = 0; i < bodyTokens.length - 3; i += 1) {
    const ident = bodyTokens[i];
    const dot = bodyTokens[i + 1];
    const methodName = bodyTokens[i + 2];
    const paren = bodyTokens[i + 3];
    if (
      ident.type === 'identifier' &&
      dot.value === '.' &&
      methodName.type === 'identifier' &&
      paren.value === '(' &&
      fieldTypeMap.has(ident.value)
    ) {
      calls.push({ targetField: ident.value, targetType: fieldTypeMap.get(ident.value), targetMethodName: methodName.value });
    }
  }
  return calls;
}
